import actionTypes from '../constants/action-types';
import type { HostingPackage } from '../types/hosting-package';
import type { PayloadAction } from '../types/actions';

function currentPackage(
  state: HostingPackage | null = null,
  action: PayloadAction<HostingPackage>
): HostingPackage | null {
  if (action.type === actionTypes.SET_CURRENT_PACKAGE) {
    return action.payload;
  }

  return state;
}

export default currentPackage;
